import { render, staticRenderFns } from "./NavSidebar.vue?vue&type=template&id=3006461b&scoped=true&"
import script from "./NavSidebar.vue?vue&type=script&lang=js&"
export * from "./NavSidebar.vue?vue&type=script&lang=js&"
import style0 from "./NavSidebar.vue?vue&type=style&index=0&id=3006461b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3006461b",
  null
  
)

export default component.exports